import { useState, useMemo } from "react";

const allCities = [
  { name: "Kansas City", route: "/cities/kansas-city", tagline: "Western Missouri expedited passport services", highlights: ["Jackson County coverage", "Serving Overland Park, Independence, Lee's Summit"], badge: "Most Popular", status: "live" },
  { name: "St. Louis", route: "/cities/st-louis", tagline: "Eastern Missouri trusted passport processing", highlights: ["St. Louis County coverage", "Serving Chesterfield, Florissant, Kirkwood"], badge: "Most Popular", status: "live" },
  { name: "Springfield", route: "/cities/springfield-mo", tagline: "Southwest Missouri passport courier service", highlights: ["Greene County coverage", "Serving Nixa, Ozark, Republic"], badge: null, status: "live" },
  { name: "Columbia", route: "/cities/columbia-mo", tagline: "Central Missouri expedited passport services", highlights: ["Boone County coverage", "Serving Jefferson City, Moberly"], badge: null, status: "live" },
  { name: "Independence", route: "/cities/independence-mo", tagline: "Kansas City metro area passport processing", highlights: ["Jackson County coverage", "Serving Blue Springs, Grain Valley"], badge: null, status: "live" },
  { name: "Lee's Summit", route: "/cities/lees-summit", tagline: "Kansas City suburbs expedited passports", highlights: ["Jackson County & Longview CC coverage", "Serving Blue Springs, Grain Valley, Raytown"], badge: "KC Metro", status: "live" },
  { name: "O'Fallon", route: "/cities/ofallon-mo", tagline: "St. Charles County passport services", highlights: ["Scott AFB military family support", "Serving Lake Saint Louis, Wentzville, St. Charles"], badge: "Military Hub", status: "live" },
  { name: "St. Joseph", route: "/cities/st-joseph-mo", tagline: "Northwest Missouri expedited passport services", highlights: ["Buchanan County & I-29 corridor", "Serving Savannah, Kearney, Maryville"], badge: "Ag Industry", status: "live" },
  { name: "St. Charles", route: "/cities/st-charles", tagline: "St. Charles County expedited passport hub", highlights: ["Historic St. Charles area", "Serving O'Fallon, Weldon Spring"], badge: null, status: "live" },
  { name: "Blue Springs", route: "/cities/blue-springs-mo", tagline: "Eastern Jackson County passport services", highlights: ["Blue Springs area coverage", "Serving Grain Valley, Oak Grove"], badge: null, status: "live" },
  { name: "Joplin", route: "/cities/joplin", tagline: "Tri-State border area expedited passport services", highlights: ["Jasper County & Tri-State coverage", "Serving Webb City, Carthage, Neosho"], badge: "Tri-State Hub", status: "live" },
  { name: "Jefferson City", route: "/cities/jefferson-city", tagline: "State capital expedited passport services", highlights: ["Cole County coverage", "Serving Columbia, California"], badge: "State Capital", status: "live" },
  { name: "Cape Girardeau", route: "/cities/cape-girardeau", tagline: "Southeast Missouri passport services", highlights: ["Cape Girardeau County coverage", "Serving Jackson, Perryville"], badge: "River Hub", status: "live" },
  { name: "Florissant", route: "/cities/florissant-mo", tagline: "North St. Louis County passport processing", highlights: ["St. Louis County coverage", "Serving Hazelwood, Ferguson"], badge: null, status: "live" },
  { name: "Chesterfield", route: "/cities/chesterfield-mo", tagline: "West St. Louis County expedited passports", highlights: ["Chesterfield area coverage", "Serving Ballwin, Wildwood"], badge: null, status: "live" },
  { name: "Wentzville", route: "/cities/wentzville-mo", tagline: "Western St. Charles County passport services", highlights: ["Wentzville area coverage", "Serving Lake Saint Louis, Troy"], badge: null, status: "live" },
  { name: "Ballwin", route: "/cities/ballwin-mo", tagline: "West St. Louis County passport processing", highlights: ["Ballwin area coverage", "Serving Ellisville, Manchester"], badge: null, status: "live" },
  { name: "Liberty", route: "/cities/liberty-mo", tagline: "Clay County expedited passport services", highlights: ["Clay County coverage", "Serving Kearney, Smithville"], badge: null, status: "live" },
  { name: "Raytown", route: "/cities/raytown-mo", tagline: "Eastern Jackson County passport processing", highlights: ["Raytown area coverage", "Serving Kansas City, Independence"], badge: null, status: "live" },
  { name: "Kirkwood", route: "/cities/kirkwood-mo", tagline: "Southwest St. Louis County passport services", highlights: ["Kirkwood area coverage", "Serving Des Peres, Webster Groves"], badge: null, status: "live" },
  { name: "Gladstone", route: "/cities/gladstone-mo", tagline: "North Kansas City metro passport processing", highlights: ["Gladstone area coverage", "Serving North Kansas City, Parkville"], badge: null, status: "live" },
  { name: "Grandview", route: "/cities/grandview-mo", tagline: "Southern Jackson County passport services", highlights: ["Grandview area coverage", "Serving Belton, Raymore"], badge: null, status: "live" },
  { name: "Belton", route: "/cities/belton-mo", tagline: "South Kansas City metro passport processing", highlights: ["Cass County coverage", "Serving Grandview, Raymore, Peculiar"], badge: null, status: "live" },
  { name: "Nixa", route: "/cities/nixa-mo", tagline: "Christian County expedited passport services", highlights: ["Nixa area coverage", "Serving Ozark, Clever"], badge: null, status: "live" },
  { name: "Ozark", route: "/cities/ozark-mo", tagline: "Christian County passport processing", highlights: ["Christian County seat", "Serving Nixa, Sparta, Finley River"], badge: null, status: "live" },
  { name: "Warrensburg", route: "/cities/warrensburg-mo", tagline: "Johnson County passport services", highlights: ["University of Central Missouri & Whiteman AFB", "Serving Knob Noster, Holden"], badge: "UCM Hub", status: "live" },
  { name: "Rolla", route: "/cities/rolla-mo", tagline: "Phelps County expedited passport processing", highlights: ["Missouri S&T & Route 66 corridor", "Serving Fort Leonard Wood, St. James"], badge: "S&T Hub", status: "live" },
  { name: "Sedalia", route: "/cities/sedalia-mo", tagline: "Pettis County expedited passport processing", highlights: ["Missouri State Fair & Whiteman AFB corridor", "Serving Knob Noster, Marshall, Warrensburg"], badge: "State Fair Hub", status: "live" },
  { name: "Hannibal", route: "/cities/hannibal", tagline: "Northeast Missouri passport processing", highlights: ["Marion County coverage", "Serving Palmyra, Monroe City"], badge: "Twain Country", status: "live" },
  { name: "Kirksville", route: "/cities/kirksville-mo", tagline: "Northeast Missouri expedited passport hub", highlights: ["Truman State & ATSU medical university town", "Serving La Plata, Edina, Macon"], badge: "Truman Bulldog", status: "live" },
  { name: "Sikeston", route: "/cities/sikeston-mo", tagline: "Missouri Bootheel passport processing", highlights: ["Scott County & I-55/I-57 crossroads", "Serving Charleston, New Madrid, Dexter"], badge: "Bootheel Hub", status: "live" },
  { name: "Poplar Bluff", route: "/cities/poplar-bluff-mo", tagline: "Butler County expedited passport services", highlights: ["Ozark foothills & Black River region", "Serving Dexter, Doniphan, Piedmont"], badge: "Ozark Gateway", status: "live" },
  { name: "Lebanon", route: "/cities/lebanon-mo", tagline: "Laclede County Route 66 passport hub", highlights: ["Bennett Spring & I-44 corridor", "Serving Waynesville, Richland, Marshfield"], badge: "Route 66", status: "live" },
  { name: "Fulton", route: "/cities/fulton-mo", tagline: "Callaway County expedited passport services", highlights: ["Westminster College & Churchill Museum", "Serving Columbia, Jefferson City, Holts Summit"], badge: "Blue Jay Pride", status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function MissouriCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Missouri Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Missouri Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Missouri</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Missouri locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}